import _ from 'lodash';
import { IFacetValue, ISearchResults } from '@components/pages/ShopV3/model/SearchResults';

export interface IAttributeFamily {
  id: string;
  title: string;
  parent?: IAttributeFamily | null;
}

export interface IAttributeFamilyFacet {
  id: string;
  count: string;
  value: string;
}

export const parseAttributeFamilyParentTitleToAggKey = (parentTitle: string) => {
  return parentTitle.toLowerCase().replace(' ', '');
};

export const parseAggKeyToAttributeFamilyParentTitle = (aggKey: string) => {
  return _.startCase(_.toLower(aggKey.slice('attribute_family_'.length).replace('_', ' ')));
};

const getAttributeFamiliesByParent = (searchResults: ISearchResults) => {
  let groupedAttrs: { [key: string]: IFacetValue[] } = {};
  Object.keys(searchResults.facets)
    .filter(
      (key) => key.startsWith('attribute_family_'), // Product type should always show.
    )
    .forEach((key) => {
      groupedAttrs = {
        ...groupedAttrs,
        [parseAggKeyToAttributeFamilyParentTitle(key)]: searchResults.facets[key].values,
      };
    });

  return groupedAttrs;
};

export const getAttributeFamilyFilters = (
  searchResults: ISearchResults
) => {
  const validParents = getAttributeFamiliesByParent(searchResults);
  let orderedAttrs = validParents;

  // Keeping 'Product Type' on top to match mocks.
  if (Object.keys(validParents)
    .includes('Product Type')) {
    // TODO: setup attribute family parent constants.
    const priorityKeysRef = {
      'Product Type': null,
    };

    orderedAttrs = Object.assign(priorityKeysRef, validParents);
  }

  // Ordering attribute family children alphabetically.
  Object.keys(orderedAttrs)
    .forEach((parent) => {
      orderedAttrs[parent] = orderedAttrs[parent].sort((a, b) => a.value.localeCompare(b.value));
    });

  return orderedAttrs;
};
